<template>
  <div class="input-group" :style="fieldStyles(input_mask)">
      <datepicker
      :disabled="(!!showDisabled())"
      v-mask="input_mask"
      format="MM/dd/yyyy"
      autocomplete="off"
      :aria-describedby="`${fieldData.field_name}_describedby`"
      :placeholder="fieldData.placeholder"
      :name="fieldData.field_name"
      :id="fieldData.field_name"
      class="col-sm-7 mx-0 px-0"
      v-validate="field_rules"
      :value="fieldData.field_value"
      v-model="fieldData.field_value"
      @closed="apiRule.present ? postRule($event.target.value, fieldData) : ''"
      :disabledDates="disabled_dates"
      :typeable="true"
      style="padding-left:0"
      :input-class="{'form-control': true, 'error': errors.has(fieldData.field_name) || fieldData.has_error}">
      </datepicker>
      <span v-bind:class="{'warning fas fa-exclamation-triangle': errors.has(fieldData.field_name)  || fieldData.has_error }"></span>
  </div>
</template>

<script>
/* eslint-disable */
import Datepicker from 'vuejs-datepicker';
import { inputFieldMixin } from '../../mixins/inputFieldMixin';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'sendPostRule'],
  mixins: [inputFieldMixin],
  data() {
    return {
      input_mask: '##/##/####', // TODO: Use config value
    };
  },
  components: {
    Datepicker,
  },
  methods: {
    handleBlur() {
      this.$emit('blur');
      if (this.apiRule.present && this.apiRule.type === 'onblur') {
        this.postRule(this.fieldData.field_value, this.fieldData)
      }
    },
  },
  mounted() {
    document.getElementById(this.fieldData.field_name).addEventListener('blur', this.handleBlur);
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/interactive/InputDateshort.vue?60dce244